export default __webpack_public_path__ + "static/pietras-1d91cd0cb64373bc2d978701fd9717ca.jpg";